import { Col, Divider, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import {
  GetPersonByIdResponse,
  GetSimeTbTreatmentPlanResponse,
  Permissions
} from 'src/api/requests'
import { Text } from 'src/components'
import { useUser } from 'src/hooks'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'

import { SimeTBTreatmentsConsumablesTables } from './SimeTBTreatmentsConsumablesTables'

type Props = {
  person?: GetPersonByIdResponse
  data?: GetSimeTbTreatmentPlanResponse
}

export const SimeTBTreatment = ({ person, data }: Props) => {
  const { t, currentLang } = useLocales()
  const { hasPermission } = useUser()

  const isPatient = !!person?.simeCode || !!person?.tarvCode

  return (
    <>
      {isPatient && (
        <Row gutter={[24, 16]}>
          <Col span={8}>
            <Flex vertical gap={8}>
              <Text>{t(`common.sime_code`)}</Text>
              <Text>{person?.simeCode}</Text>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex vertical gap={8}>
              <Text>{t(`common.tarv_code`)}</Text>
              <Text>{person?.tarvCode}</Text>
            </Flex>
          </Col>
        </Row>
      )}

      <Row gutter={[24, 16]}>
        <Col span={8}>
          <Flex vertical gap={8}>
            <Text>{t('treatments.treatment_type')}</Text>
            <Text>
              {data?.treatmentType?.translation?.[currentLang?.value]}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={8}>
            <Text>{t('persons.treatment.start_date')}</Text>
            <Text>{dayjs(data?.created).format(dayMonthYearBackSlash)}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={8}>
            <Text>{t('persons.treatment.end_date')}</Text>
            <Text>{dayjs(data?.endDate).format(dayMonthYearBackSlash)}</Text>
          </Flex>
        </Col>

        {hasPermission(
          Permissions.TREATMENT_TREATMENT_PLAN_VIEW_PRESCRIBED
        ) && (
          <>
            <Divider />
            <Flex key={1} vertical gap={24} style={{ width: '100%' }}>
              <Text size="xl">
                {t('persons.treatment.treatment_prescribed')}
              </Text>

              <SimeTBTreatmentsConsumablesTables data={data} />
            </Flex>
          </>
        )}
      </Row>
    </>
  )
}
